<template>
  <q-form class="row no-wrap items-center q-gutter-sm" @submit="importBackupAndRedirect">
    <q-file
      v-model="importFile"
      accept="application/json"
      :label="t('settings.import_export.import.select_file')"
      max-files="1"
      outlined
      dense
      class="col"
    >
      <template #prepend>
        <q-icon name="attach_file" />
      </template>

      <template #append>
        <q-btn
          v-if="importFile !== null"
          flat
          round
          dense
          icon="close"
          class="cursor-pointer"
          @click.stop.prevent="importFile = null"
        />
      </template>
    </q-file>

    <q-btn
      :disable="!importFile"
      outline
      color="primary"
      class="col-auto"
      icon="upload"
      type="submit"
      :label="t('settings.import_export.import.import')"
    />
  </q-form>
</template>

<script setup lang="ts">
import { useImportExport } from '../../composables/ImportExport'
import { useTranslation } from '../../composables/i18n'
import { handleError } from '../../helpers/error.ts'
import { useRouter } from 'vue-router'

const t = useTranslation()
const props = defineProps<{ confirmImport: boolean }>()
const router = useRouter()

const { importFile, importBackup } = useImportExport({ confirmImport: props.confirmImport })

const importBackupAndRedirect = async () => {
  try {
    const imported = await importBackup()
    if (imported) router.push('/').then(() => router.go(0))
  } catch (e) {
    handleError(e, true)
  }
}
</script>
